import React, { useState } from 'react'
import { reduxForm, Field } from 'redux-form'
import { useHistory } from 'react-router-dom'

import Subnav from '../../../../Shared/Subnav'
import Button from '../../../../Shared/Button'
import Card from '../../../../Shared/Card'
import WrappedInput from '../../../../Shared/Forms/WrappedInput'
import DynamicInput from '../../../../Shared/Forms/DynamicInput'
import { StateTabBar } from '../../../../Shared/TabBar'

import Auth from './Auth'
import Headers from './Headers'
import Params from './Params'
import Body from './Body'
import Row from './Row'

import styles from './API.module.css'

export const FORM_NAME = 'APIStepForm'

const METHOD_OPTIONS = ['get', 'post', 'put', 'patch', 'delete'].map(m => ({
  label: m.toUpperCase(),
  value: m,
}))

const TABS = [
  { name: 'Authentication', key: 'auth' },
  { name: 'Headers', key: 'headers' },
  { name: 'Query Params', key: 'params' },
  { name: 'Body', key: 'body' },
]

const Tabs = function Tabs({ activeTab, ...props }) {
  switch (activeTab) {
    case 'auth':
      return <Auth {...props} />
    case 'headers':
      return <Headers {...props} />
    case 'params':
      return <Params {...props} />
    case 'body':
      return <Body {...props} />
    default:
      return null
  }
}

const Form = function APIStepForm({
  handleSubmit,
  submitting,
  stepId,
  action,
}) {
  const history = useHistory()
  const [activeTab, setActiveTab] = useState('auth')

  return (
    <form onSubmit={handleSubmit}>
      <Subnav
        title="Configure Step"
        actions={
          <>
            <Button text onClick={history.goBack}>
              Back
            </Button>
            {action.details.steps.length > 1 || !action.draft ? (
              <Button>Save</Button>
            ) : (
              <Button>Next: Configure Action</Button>
            )}
          </>
        }
      />
      <Card>
        <Row>
          <Field
            name="method"
            component={WrappedInput}
            options={METHOD_OPTIONS}
            label="Method"
            className={styles.method}
          />
          <Field
            name="url"
            component={DynamicInput}
            label="URL"
            className={styles.url}
            actionId={action.id}
            stepId={stepId}
          />
        </Row>
        <div className={styles.tabs}>
          <StateTabBar
            tabs={TABS}
            onChangeTab={setActiveTab}
            activeTab={activeTab}
          />
        </div>
        <Tabs activeTab={activeTab} action={action} stepId={stepId} />
      </Card>
    </form>
  )
}

export default reduxForm({
  form: FORM_NAME,
})(Form)
